function data(state = [], action)
{
	const d = {...state};
	const data = action.data;
		switch (action.type) {
		case "CHANGE_LANG":
			d.lang = data;
			break;
		case "UPD_AUTH":
			d.auth = data;
			break;
		case "UPD_FIRST_LOGIN":
			d.justLogged = data;
			break;
		case "UPD_LOGIN":
			d.auth = data.t;
			d.userInfo = {
				name: data.name,
				uid: data.id,
				id: data.firm,
				firm: data.firm,
				rank: data.rank,
			};
			d.otherDepartments = data.otherDepartments.map(d => Number(d));
			d.groups = data.groups;
			d.cachedData = [];
			d.justLogged = true;
		break;
		case "UPD_GROUPS":
			d.groups = data.groups;
		break;
		case "UPD_REMOV_OBS":

			break;
		case "UPD_CACHE":

			if(!d.cachedData)
			{
				d.cachedData = [];
			}
			d.cachedData = [];
			break;
			let newCache = [...d.cachedData];
			let temp = d.cachedData.find(elem => elem.from === data.from && elem.to === data.to && elem.api === data.api);
			if(!temp)
			{
				newCache = newCache.filter(d => d.api !== data.api);
			}
			let newElem = temp ? {...temp} : {
				from: data.from,
				to: data.to,
				api: data.api
			};
			newElem.lastUpdate = Date.now();
			newElem.data = data.data;
			d.cachedData = [...newCache, newElem];
		break;
		
		default:
			break;
	}
	return d;//state;
}

export default data;


// WEBPACK FOOTER //
// ./src/reducers/data.js